/* That's Classic — car page: swipeable gallery, thumbnails, lightbox, tabs. */
(() => {
  const initGallery = (root) => {
    const track = root.querySelector('[data-tc-track]');
    if (!track) return;
    const slides = [...track.children];
    const thumbs = [...root.querySelectorAll('[data-tc-thumb]')];
    const count = root.querySelector('[data-tc-count]');
    const lightbox = root.querySelector('[data-tc-lightbox]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const goTo = (i, smooth = true) => {
      const slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };

    // Keep counter + active thumb in sync with the visible slide
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const i = Number(e.target.dataset.index);
          // Autoplay (muted) the video slide in view, pause any other
          slides.forEach((sl) => {
            const v = sl.querySelector('video');
            if (!v) return;
            if (sl === e.target && !reduceMotion) v.play().catch(() => {});
            else v.pause();
          });
          if (count) count.textContent = `${i + 1} / ${slides.length}`;
          root.querySelector('.tc-gallery__stage')?.toggleAttribute('data-on-video', e.target.dataset.mediaType === 'video' || e.target.dataset.mediaType === 'external_video');
          thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.tcThumb) === i));
        });
      },
      { root: track, threshold: 0.6 }
    );
    slides.forEach((s) => io.observe(s));

    const openLightbox = (i = 0) => {
      if (!lightbox) return;
      lightbox.querySelectorAll('img[data-src]').forEach((img) => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
      track.querySelectorAll('video').forEach((v) => v.pause());
      lightbox.showModal();
      document.documentElement.style.overflow = 'hidden';
      const target = lightbox.querySelector(`[data-tc-lb-img="${i}"]`);
      if (target) requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    };

    thumbs.forEach((t) =>
      t.addEventListener('click', () => {
        const i = Number(t.dataset.tcThumb);
        // Last thumb with "+N" opens the full gallery
        if (t.querySelector('.tc-gallery__more')) openLightbox(i);
        else goTo(i);
      })
    );

    // Photos open the full-screen gallery; video slides keep their own controls
    slides.forEach((s) => {
      if (s.dataset.mediaType && s.dataset.mediaType !== 'image') return;
      s.addEventListener('click', () => openLightbox(Number(s.dataset.index)));
    });
    root.querySelector('[data-tc-open-gallery]')?.addEventListener('click', () => openLightbox(0));

    track.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const current = Math.round(track.scrollLeft / track.clientWidth);
      goTo(current + (e.key === 'ArrowRight' ? 1 : -1));
      e.preventDefault();
    });

    if (lightbox) {
      lightbox.querySelector('[data-tc-close]')?.addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) lightbox.close();
      });
      lightbox.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
        lightbox.querySelectorAll('video').forEach((v) => v.pause());
      });
    }
  };

  const initTabs = (root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const select = (tab, focus = false) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        const dir = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!dir) return;
        select(tabs[(i + dir + tabs.length) % tabs.length], true);
        e.preventDefault();
      });
    });
  };

  // Mobile: collapse long descriptions behind a toggle
  const initReadMore = (btn) => {
    const body = btn.previousElementSibling;
    const mq = window.matchMedia('(max-width: 749px)');
    const apply = () => {
      body.classList.remove('is-collapsed');
      const tooLong = mq.matches && body.scrollHeight > 520;
      btn.hidden = !tooLong;
      if (tooLong && btn.getAttribute('aria-expanded') !== 'true') body.classList.add('is-collapsed');
    };
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open);
      body.classList.toggle('is-collapsed', !open);
      btn.textContent = open ? 'Show less' : 'Read the full story';
    });
    mq.addEventListener('change', apply);
    apply();
  };

  const init = () => {
    document.querySelectorAll('[data-tc-readmore-toggle]').forEach(initReadMore);
    document.querySelectorAll('[data-tc-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-tc-tabs]').forEach(initTabs);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
